import { systemClockNowmqi0s7hoicxq as systemClockNow } from './InstantJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SystemClass;
function System() {
  if (SystemClass === VOID) {
    class $ {
      hr() {
        return systemClockNow();
      }
    }
    initMetadataForObject($, 'System');
    SystemClass = $;
  }
  return SystemClass;
}
var System_instance;
function System_getInstance() {
  return System_instance;
}
//region block: init
System_instance = new (System())();
//endregion
//region block: exports
export {
  System_instance as System_instance2n5ytli8ed176,
};
//endregion

//# sourceMappingURL=Clock.mjs.map
